import BaseButton from '@/components/BaseButton'
import SuccessDialog from '@/components/SuccessDialog'
import ErrorDialog from '@/components/ErrorDialog'
import goTopButton from '@/components/GoTopButton'
import goBottomButton from '@/components/GoBottomButton'
import { required } from '@vuelidate/validators'
import Pager from '@/components/PagerComponent'

export default {

  components: {
    Pager,
    BaseButton,
    SuccessDialog,
    ErrorDialog,
    goTopButton,
    goBottomButton
  },

  data () {
    return {
      excelFile: undefined,
      base64File: undefined,
      currentProduct: {},
      products: [],
      checkedProducts: [],
      allSelected: false,
      criterias: {
        selectedDistributorRef: ''
      },
      displayedProducts: [],
      distributors: [],
      responseErr: '',
      error: false,
      validationError: false,
      isProcessing: false,
      isDistributorLocked: true
    }
  },

  methods: {
    chooseFile () {
      document.getElementById('fileUpload').click()
    },
    onFileChange (event) {
      this.excelFile = event.target.files ? event.target.files[0] : null
      if (this.excelFile) {
        this.extractProducts(this.excelFile)
      } else {
        this.showError('Erreur lecture fichier')
      }
    },

    async extractProducts (fileTocontrol) {
      this.isProcessing = true
      this.error = false

      this.base64File = await this.toBase64(fileTocontrol)

      await this.$store.dispatch('products/extract', this.base64File).then(
        result => {
          this.isProcessing = false
          this.products = result
        },
        error => {
          this.isProcessing = false
          this.error = true
          this.responseErr = (error || 'BAD_REQUEST').toUpperCase()
          this.showError(this.responseErr)
          this.reset()
        }
      )
    },

    createProducts () {
      if (this.checkedProducts && this.checkedProducts.length > 0) {
        this.runCreateProducts(this.checkedProducts, this.base64File)
      } else {
        this.showError('Aucun produit selectionné')
      }
    },

    async runCreateProducts (checkedProductsRefs, base64File) {
      this.isProcessing = true
      this.error = false

      await this.$store.dispatch('products/create', {
        selectedProducts: checkedProductsRefs,
        base64EncodedFile: base64File
      }).then(
        () => {
          this.isProcessing = false
          this.showSuccess('Produits créés avec succes')
          this.reset()
        },
        error => {
          this.isProcessing = false
          this.error = true
          // Si probleme de validation du dossier de paramétrage, on affiche les erreurs
          if (error.createProductListOutput &&
            ['CONVERSION_ERROR', 'COM_002'].includes(error.createProductListOutput.responseCode)) {
            let conversionErrorMessage = '<div><div>' + this.$i18n.t('error.PARAM_CONTROL_ERROR') + '</div>'
            for (const violation of Object.values(error.createProductListOutput.productViolations || [])) {
              // Ajout du nom du produit en erreur
              conversionErrorMessage += '<div class="mt-3">' + violation.productRef + ' : </div>'
              for (const violationForProduct of Object.values(violation.violations)) {
                // Ajout des violations retournées
                conversionErrorMessage += '<li class="ms-3">' + violationForProduct.name + ', ' + violationForProduct.message + '</li>'
              }
            }
            conversionErrorMessage += '</div>'
            this.showErrorContent(conversionErrorMessage)
          } else {
            this.responseErr = (error || 'BAD_REQUEST').toUpperCase()
            this.showError(this.responseErr)
          }
        }
      )
    },

    async toBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },

    async showDetails (product) {
      this.currentProduct = product
    },

    selectAll () {
      if (!this.allSelected) {
        this.checkedProducts = []
        this.products.forEach(element => {
          this.checkedProducts.push(element.params.prb1)
        })
      } else {
        this.checkedProducts = []
      }
    },

    showError (msg) {
      this.$refs.errorDialogRef.showError(msg)
    },

    showErrorContent (content) {
      this.$refs.errorDialogRef.showErrorContent(content)
    },

    showSuccess (msg) {
      this.$refs.successDialogRef.showSuccess(msg)
    },

    reset () {
      this.products = []
      this.checkedProducts = []
      if (this.$refs.fileUpload) {
        this.$refs.fileUpload.value = null
      }
      this.allSelected = false
      this.validationError = false
      this.error = false
    }
  },

  validations() {
    return {
      criterias: {
        selectedDistributorRef: { required }
      }
    }
  }
}
